import ManageAssignment from '../../../views/Personnel/Letter/ManageAssignment.letter.view';

export default ManageAssignment;
